import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetApiV1RefundsEligibilityOrderId200,
  GetApiV1RefundsEligibilityOrderId400,
  GetApiV1RefundsEligibilityOrderId401,
  GetApiV1RefundsEligibilityOrderId500,
  GetApiV1RefundsMyRequests200,
  GetApiV1RefundsMyRequests401,
  GetApiV1RefundsMyRequests500,
  PostApiV1RefundsCancelSubscription200,
  PostApiV1RefundsCancelSubscription400,
  PostApiV1RefundsCancelSubscription401,
  PostApiV1RefundsCancelSubscription500,
  PostApiV1RefundsCancelSubscriptionBody,
  PostApiV1RefundsRequest200,
  PostApiV1RefundsRequest400,
  PostApiV1RefundsRequest401,
  PostApiV1RefundsRequest500,
  PostApiV1RefundsRequestBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * AI API 사용량을 기준으로 환불 신청을 처리합니다.
- AI API를 사용하지 않았으면 전액 환불 가능
- AI API를 사용했으면 환불 불가능

 * @summary 구독 환불 신청
 */
export const postApiV1RefundsRequest = (
    postApiV1RefundsRequestBody: PostApiV1RefundsRequestBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PostApiV1RefundsRequest200>(
      {url: `/api/v1/refunds/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiV1RefundsRequestBody
    },
      options);
    }
  


export const getPostApiV1RefundsRequestMutationOptions = <TError = PostApiV1RefundsRequest400 | PostApiV1RefundsRequest401 | PostApiV1RefundsRequest500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1RefundsRequest>>, TError,{data: PostApiV1RefundsRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1RefundsRequest>>, TError,{data: PostApiV1RefundsRequestBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1RefundsRequest>>, {data: PostApiV1RefundsRequestBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1RefundsRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1RefundsRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1RefundsRequest>>>
    export type PostApiV1RefundsRequestMutationBody = PostApiV1RefundsRequestBody
    export type PostApiV1RefundsRequestMutationError = PostApiV1RefundsRequest400 | PostApiV1RefundsRequest401 | PostApiV1RefundsRequest500

    /**
 * @summary 구독 환불 신청
 */
export const usePostApiV1RefundsRequest = <TError = PostApiV1RefundsRequest400 | PostApiV1RefundsRequest401 | PostApiV1RefundsRequest500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1RefundsRequest>>, TError,{data: PostApiV1RefundsRequestBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1RefundsRequest>>,
        TError,
        {data: PostApiV1RefundsRequestBody},
        TContext
      > => {

      const mutationOptions = getPostApiV1RefundsRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 주문 ID를 기반으로 환불 가능 여부를 확인합니다.
AI API 사용량을 조회하여 환불 가능 여부를 판단합니다.

 * @summary 환불 가능 여부 확인
 */
export const getApiV1RefundsEligibilityOrderId = (
    orderId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiV1RefundsEligibilityOrderId200>(
      {url: `/api/v1/refunds/eligibility/${orderId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1RefundsEligibilityOrderIdQueryKey = (orderId: string,) => {
    return [`/api/v1/refunds/eligibility/${orderId}`] as const;
    }

    
export const getGetApiV1RefundsEligibilityOrderIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError = GetApiV1RefundsEligibilityOrderId400 | GetApiV1RefundsEligibilityOrderId401 | GetApiV1RefundsEligibilityOrderId500>(orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1RefundsEligibilityOrderIdQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>> = ({ signal }) => getApiV1RefundsEligibilityOrderId(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1RefundsEligibilityOrderIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>>
export type GetApiV1RefundsEligibilityOrderIdInfiniteQueryError = GetApiV1RefundsEligibilityOrderId400 | GetApiV1RefundsEligibilityOrderId401 | GetApiV1RefundsEligibilityOrderId500

/**
 * @summary 환불 가능 여부 확인
 */
export const useGetApiV1RefundsEligibilityOrderIdInfinite = <TData = Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError = GetApiV1RefundsEligibilityOrderId400 | GetApiV1RefundsEligibilityOrderId401 | GetApiV1RefundsEligibilityOrderId500>(
 orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiV1RefundsEligibilityOrderIdInfiniteQueryOptions(orderId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1RefundsEligibilityOrderIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError = GetApiV1RefundsEligibilityOrderId400 | GetApiV1RefundsEligibilityOrderId401 | GetApiV1RefundsEligibilityOrderId500>(orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1RefundsEligibilityOrderIdQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>> = ({ signal }) => getApiV1RefundsEligibilityOrderId(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1RefundsEligibilityOrderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>>
export type GetApiV1RefundsEligibilityOrderIdQueryError = GetApiV1RefundsEligibilityOrderId400 | GetApiV1RefundsEligibilityOrderId401 | GetApiV1RefundsEligibilityOrderId500

/**
 * @summary 환불 가능 여부 확인
 */
export const useGetApiV1RefundsEligibilityOrderId = <TData = Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError = GetApiV1RefundsEligibilityOrderId400 | GetApiV1RefundsEligibilityOrderId401 | GetApiV1RefundsEligibilityOrderId500>(
 orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsEligibilityOrderId>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiV1RefundsEligibilityOrderIdQueryOptions(orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 현재 사용자의 모든 환불 신청 내역을 조회합니다.
 * @summary 사용자의 환불 신청 목록 조회
 */
export const getApiV1RefundsMyRequests = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiV1RefundsMyRequests200>(
      {url: `/api/v1/refunds/my-requests`, method: 'GET', signal
    },
      options);
    }
  

export const getGetApiV1RefundsMyRequestsQueryKey = () => {
    return [`/api/v1/refunds/my-requests`] as const;
    }

    
export const getGetApiV1RefundsMyRequestsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError = GetApiV1RefundsMyRequests401 | GetApiV1RefundsMyRequests500>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1RefundsMyRequestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>> = ({ signal }) => getApiV1RefundsMyRequests(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1RefundsMyRequestsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>>
export type GetApiV1RefundsMyRequestsInfiniteQueryError = GetApiV1RefundsMyRequests401 | GetApiV1RefundsMyRequests500

/**
 * @summary 사용자의 환불 신청 목록 조회
 */
export const useGetApiV1RefundsMyRequestsInfinite = <TData = Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError = GetApiV1RefundsMyRequests401 | GetApiV1RefundsMyRequests500>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiV1RefundsMyRequestsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetApiV1RefundsMyRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError = GetApiV1RefundsMyRequests401 | GetApiV1RefundsMyRequests500>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1RefundsMyRequestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>> = ({ signal }) => getApiV1RefundsMyRequests(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV1RefundsMyRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>>
export type GetApiV1RefundsMyRequestsQueryError = GetApiV1RefundsMyRequests401 | GetApiV1RefundsMyRequests500

/**
 * @summary 사용자의 환불 신청 목록 조회
 */
export const useGetApiV1RefundsMyRequests = <TData = Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError = GetApiV1RefundsMyRequests401 | GetApiV1RefundsMyRequests500>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV1RefundsMyRequests>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiV1RefundsMyRequestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 구독을 취소합니다. 환불이 아닌 다음 결제일부터 결제가 중단됩니다.
현재 결제 기간은 그대로 이용 가능합니다.

 * @summary 구독 취소 (환불 아님)
 */
export const postApiV1RefundsCancelSubscription = (
    postApiV1RefundsCancelSubscriptionBody: PostApiV1RefundsCancelSubscriptionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PostApiV1RefundsCancelSubscription200>(
      {url: `/api/v1/refunds/cancel-subscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiV1RefundsCancelSubscriptionBody
    },
      options);
    }
  


export const getPostApiV1RefundsCancelSubscriptionMutationOptions = <TError = PostApiV1RefundsCancelSubscription400 | PostApiV1RefundsCancelSubscription401 | PostApiV1RefundsCancelSubscription500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1RefundsCancelSubscription>>, TError,{data: PostApiV1RefundsCancelSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1RefundsCancelSubscription>>, TError,{data: PostApiV1RefundsCancelSubscriptionBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1RefundsCancelSubscription>>, {data: PostApiV1RefundsCancelSubscriptionBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1RefundsCancelSubscription(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1RefundsCancelSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1RefundsCancelSubscription>>>
    export type PostApiV1RefundsCancelSubscriptionMutationBody = PostApiV1RefundsCancelSubscriptionBody
    export type PostApiV1RefundsCancelSubscriptionMutationError = PostApiV1RefundsCancelSubscription400 | PostApiV1RefundsCancelSubscription401 | PostApiV1RefundsCancelSubscription500

    /**
 * @summary 구독 취소 (환불 아님)
 */
export const usePostApiV1RefundsCancelSubscription = <TError = PostApiV1RefundsCancelSubscription400 | PostApiV1RefundsCancelSubscription401 | PostApiV1RefundsCancelSubscription500,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1RefundsCancelSubscription>>, TError,{data: PostApiV1RefundsCancelSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1RefundsCancelSubscription>>,
        TError,
        {data: PostApiV1RefundsCancelSubscriptionBody},
        TContext
      > => {

      const mutationOptions = getPostApiV1RefundsCancelSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    